import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetDepositDetailsQuery } from '../slices/depositsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import DepositCarousel from '../components/DepositCarousel';

const DepositScreen = () => {
  const { id: depositId } = useParams();
  const { data: deposit, isLoading, error } = useGetDepositDetailsQuery(depositId);

  const renderDepositDetails = () => (
    <>
      <Meta title={deposit.date} description={deposit.account} />
      <Row>
        <Col md={6}>
          {/* Display deposit images using DepositCarousel */}
          {deposit.images && deposit.images.length > 0 ? (
            <DepositCarousel images={deposit.images} />
          ) : (
            <Message variant="info">No images available for this deposit</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{deposit.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {deposit.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {deposit.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {deposit.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{deposit.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{deposit.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {deposit.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="deposit-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {deposit.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderDepositDetails()
      )}
    </>
  );
};

export default DepositScreen;